//消息头列表
export enum SUB {
    //纯同步到房间不走head
    SCSubGameSync = null,
    //帧同步 单帧
    SyncMessage = 50,
    //帧同步 队列
    FpsSyncListMsg = 51,
    //公用 101 - 501
    SubBase = 100,
    CSubLoginServer = 101,
    CSubLogoutGame = 102,
    CSubLoginGame = 103,
    CSubMatchRoom = 104,
    CSubExitRoom = 105,
    CSubGetHostUid = 106,
    //公用 101 - 501
    SSubLoginServer = 501,
    SSubLogoutGame = 502,
    SSubLoginGame = 503,
    SSubMatchRoom = 504,
    SSubExitRoom = 505,
    SSubUpdateHostUid = 506,
    SSubRushLogin = 507,
    //FPS游戏
    SSubFpsGameStart = 5001,
}


























